// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2bt4q","header":"PatientQuestionnaire_header__NXxRe","info":"PatientQuestionnaire_info__TMeCM"};